import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, forkJoin, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Notificacion, sortNotificationsByDate } from '../yalo.types';
import { EstablecimientosService } from './establecimientos.service';

@Injectable()
export class YaloService {
  private _multiFactorAuth = new BehaviorSubject<{
    [key: string]: boolean | null;
  }>(null);
  public multiFactorAuth$ = this._multiFactorAuth.asObservable();

  // TODO: Move to a dedicated service like EstablecimientosService
  private _notificaciones = new BehaviorSubject<Notificacion[]>([]);
  readonly notificaciones$ = this._notificaciones
    .asObservable()
    .pipe(
      map((notificaciones) => notificaciones.sort(sortNotificationsByDate))
    );

  private _notificationSelected = new BehaviorSubject<number>(null);
  readonly notificationSelected$ = this._notificationSelected.asObservable();

  readonly selectedNotification$ = combineLatest([
    this.notificaciones$,
    this.notificationSelected$,
  ]).pipe(
    map(([notificaciones, selectedNotificationId]) =>
      notificaciones.find((n) => n.CodNotificacion === selectedNotificationId)
    )
  );

  constructor(
    private _http: HttpClient,
    private establecimientosService: EstablecimientosService
  ) {}

  set multiFactorAuth(multiFactorAuth: { [key: string]: boolean | null }) {
    this._multiFactorAuth.next(multiFactorAuth);
  }

  get multiFactorAuth() {
    return this._multiFactorAuth.getValue();
  }

  getCodEstablecimiento() {
    return this.establecimientosService.getCodEstablecimiento();
  }

  getMultiFactorAuth(): Observable<{ [key: string]: boolean | null }> {
    const sources = {
      app: this._http.get<boolean | null>(
        `${environment.API_URL}/EstadoMultifactorApp`
      ),
      sms: this._http.get<boolean | null>(
        `${environment.API_URL}/EstadoMultifactorSMS`
      ),
      email: this._http.get<boolean | null>(
        `${environment.API_URL}/EstadoMultifactorCorreo`
      ),
    };
    return forkJoin(sources).pipe(
      tap((multiFactorAuth) => {
        this.multiFactorAuth = multiFactorAuth;
      })
    );
  }

  setOrganization(CodOrganizacion: number) {
    return this._http.get(
      `${environment.API_URL}/SetOrganizacion/${CodOrganizacion}`
    );
  }

  getMyOrgs() {
    return this._http.get<any[]>(`${environment.API_URL}/ListOrganizacion`);
  }

  getNotifications() {
    return this._http
      .get<Notificacion[]>(`${environment.API_URL}/Notificaciones`)
      .pipe(
        tap((notificaciones) => {
          // //Set random Category
          // notificaciones.map((x) => {
          //   const randomNum = Math.random() * 3;
          //   x.CodCategoria = +(randomNum < 1
          //     ? (randomNum + 1).toFixed(0)
          //     : randomNum.toFixed(0));
          //   return x;
          // });
          return this._notificaciones.next(notificaciones);
        })
      );
  }

  selectNotification(CodNotificacion: number) {
    this._notificationSelected.next(CodNotificacion);
  }
}
